import DashboardUser from "./DasboardUser";
import DashboardAdmin from "./DashboardAdmin";

function Dashboard() {
  const roles = localStorage.getItem("roles");
  return (
    <>
      {roles && roles.includes("admin") ? (
        <DashboardAdmin />
      ) : (
        <DashboardUser />
      )}
    </>
  );
}

export default Dashboard;
